import { render, staticRenderFns } from "./WalletAddressSettings.vue?vue&type=template&id=3d59c64e&"
import script from "./WalletAddressSettings.vue?vue&type=script&lang=js&"
export * from "./WalletAddressSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports